import React, { useState, useEffect } from "react";
import Layout from "../../components/layout";
import axios from "axios";
import { Col, Row, Card } from "antd";
import toast from "react-hot-toast";



function DoctorSlotsStatus() {

  const [doctorsStatus, setDoctorsStatus] = useState([]);

  useEffect(() => {
    const fetchDoctorsStatus = async () => {
      try {
        const response = await axios.get("/api/bookAppointment/doctor-slots-status", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.data.success) {
          setDoctorsStatus(response.data.doctorsStatus);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error("Something went wrong");
      }
    };
    fetchDoctorsStatus();
  }, []);

  return (
  <Layout>
    <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
      <Card title="Doctor Slots Reset Status" className="mv p-2">
        <Row gutter={20} className="p-4">
          {doctorsStatus.map((doctor) => (
            <Col span={8} xs={24} sm={24} lg={8} key={doctor._id} className="card-space">
              <Card title={doctor.firstName} className="user-line">
                <p>Total Slots: {doctor.totalSlots}</p>
                <p>Available Slots: {doctor.availableSlots}</p>
                <p>Used Slots: {doctor.occupiedSlots}</p>
                <p>Days Until Reset: {doctor.daysUntilReset}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  </Layout>
  );
}
export default DoctorSlotsStatus;
